import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';
import { File } from 'src/app/core/entities/file/file';

interface Issue {
  id: string;
  prefixedNumber: string;
  title: string;
  description?: any;
  labels?: any[];
  files?: any[];
}

@Component({
  selector: 'app-issues-control-value-view, [app-issues-control-value-view]',
  templateUrl: './issuesInput-control-value-view.component.html',
  styleUrls: ['./issuesInput-control-value-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IssuesInputControlValueViewComponent {

  // Signal inputs
  readonly controlTemplate = input<ControlTemplate>();

  // Computed signals
  readonly subControls = computed(() => this.controlTemplate()?.controls || []);

  constructor() {
  }

  getIssues(subControl: ControlTemplate): Issue[] {
    const value = subControl?.settings?.value;
    if (!value || (Array.isArray(value) && value.length === 0)) {
      return [];
    }
    return Array.isArray(value) ? value : [value];
  }

  hasIssues(subControl: ControlTemplate): boolean {
    return this.getIssues(subControl).length > 0;
  }

  getIssueFileObjects(issue: Issue): File[] {
    const result: File[] = [];
    if (issue?.files && Array.isArray(issue.files)) {
      issue.files.forEach((fileEntry: any) => {
        if (fileEntry?.file && fileEntry.file?.ownerState !== 'ARCHIVED') {
          result.push(fileEntry.file);
        }
      });
    }
    return result;
  }

}
